/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { Environment } from '../../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../../axiosApi';

export type TTipoContaFinanceira = 'banco' | 'caixa' | 'cofre' | 'recebiveis';

export interface IListagemContaBancaria {
  idconta: string;
  nomebanco?: string;
  agencia?: string;
  numeroconta?: string;
  titular: string;
  status: boolean;
  banco?: string;
  tipo: TTipoContaFinanceira;
}
export interface IDetalheContaBancaria {
  nomebanco?: string;
  agencia?: string;
  numeroconta?: string;
  titular: string;
  status: boolean;
  banco?: string;
  tipo: TTipoContaFinanceira;
}
export interface IGetContaBancaria {
  nomebanco?: string;
  agencia?: string;
  numeroconta?: string;
  status: boolean;
  titular: string;
  banco?: string;
  tipo: TTipoContaFinanceira;
}

type TComTotalCount = {
    data: IListagemContaBancaria[];
    totalCount: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (page = 1, filter = '', limit = Environment.LIMITE_DE_LINHAS): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/contabancaria?page=${page}&limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || limit),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getAllList = async (filter = '', id = ''): Promise<TComTotalCount | Error> => {
  try {

    const urlRelativa: string = id === '' ?  `/contabancarialist?limit=5&filter=${filter}` : `/contabancarialist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (id: string): Promise<IGetContaBancaria | Error> => {
  try {
    const { data } = await Api.get(`/contabancaria/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: IDetalheContaBancaria): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheContaBancaria>('/contabancaria', {idconta: guuid, ...dados});

    if (Object.keys(data).length === 0) {
      return 'ok';
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheContaBancaria): Promise<void | Error> => {
  try {
    await Api.put(`/contabancaria/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/contabancaria/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const ContaBancariaService = {
  getAll,
  getAllList,
  create,
  getById,
  updateById,
  deleteById,
};